/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { useFloating, useClick, useInteractions, useFloatingNodeId, FloatingPortal, FloatingFocusManager, FloatingOverlay, size, } from '@floating-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTh } from '@fortawesome/pro-solid-svg-icons';
import style from './MobileMenuButton.module.scss';
import { MobileMenuList } from './MobileMenuList';
export function MobileMenuButton() {
    const [isOpen, setIsOpen] = useState(false);
    const nodeId = useFloatingNodeId();
    const { refs, context } = useFloating({
        nodeId,
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            size({
                apply: ({ availableWidth, elements }) => {
                    Object.assign(elements.floating.style, {
                        width: availableWidth,
                        height: '100vh',
                    });
                },
            }),
        ],
    });
    const click = useClick(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([click]);
    return (React.createElement("div", null,
        React.createElement("button", { type: "button", ref: refs.setReference, ...getReferenceProps(), className: style.button },
            React.createElement(FontAwesomeIcon, { className: style.menuIcon, icon: faTh })),
        React.createElement(FloatingPortal, null, isOpen && (React.createElement(FloatingOverlay, { lockScroll: true, style: { zIndex: 1090 } },
            React.createElement(FloatingFocusManager, { context: context },
                React.createElement("div", { className: style.overlay, ref: refs.setFloating, ...getFloatingProps() },
                    React.createElement(MobileMenuList, { onDismissed: () => setIsOpen(false) }))))))));
}
